import "../index.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

export default function KeyAvaileble(props) {
  const { limit } = props;

  return (
    <div style={{}}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          // justifyContent: "flex-end",
          gap: "15px",
        }}
      >
        <div style={{ fontWeight: 700, fontSize: "20px" }}>
          Доступные ключи:
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "30px",
            border: "1px solid black",
            padding: "20px 15px",
            fontSize: "26px",
            color: "white",
            backgroundColor: limit < 5 ? "red" : "green",
          }}
        >
          {limit}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        <Link to={"/main/price"}>
          <Button variant="contained" size="small" color="success">
            Получить ключи
          </Button>
        </Link>
      </div>
    </div>
  );
}
